import React, { useMemo } from 'react';
import { Pivot } from 'api';
import { useDispatch } from 'react-redux';
import { Button, Form } from 'antd';
import styles from './index.module.scss';
import ModifyPasswordPriv from 'lib/publicUsecase/ModifyPasswordPriv';
import { ModifyPasswordResStatus } from 'lib/publicUsecase/type';
import { getMobile, setAuthUserInfo } from 'data/storage';
import { noop } from 'lodash';
import { appMessageError, appMessageSuccess } from 'model/app';
import LoginGraphicCapatchaItem from 'component/AuthForm/LoginGraphicCapatchaItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
import { getSessionId } from 'util/session';
import { getGraphicCaptchaUrl } from 'util/graphicCaptcha';
import { useStore } from 'page/Login/component/useStore';

interface IProps {
  onSuccess: () => void;
}

interface FormData {
  oldPassword: string;
  mobile: string;
  password: string;
  confirmPassword: string;
  graphicCaptcha: string;
}

const ModifyPasswordComponent: React.FC<IProps> = ({ onSuccess }) => {
  const [form] = Form.useForm<FormData>();
  const dispatch = useDispatch();

  const { formStore, stateStore, stateData, handleFromDataChange, handleStateDataChange } = useStore<FormData>(
    {
      mobile: getMobile(),
      oldPassword: '',
      password: '',
      confirmPassword: '',
      graphicCaptcha: ''
    },
    {
      modifyLoading: false,
      graphicCaptchaUrl: '',
      graphicCaptchaError: '',
      oldPasswordError: '',
      passwordError: ''
    }
  );

  const modifyPassword = new ModifyPasswordPriv({
    API: {
      getSessionId,
      getGraphicCaptchaUrl,
      modifyPasswordPriv: (data: any) => Pivot.modifyPasswordPriv(data).toPromise()
    },
    formStore: formStore as any,
    stateStore
  });

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    handleFromDataChange(newData);
  }

  const { refrashGraphicCaptchaUrl, fetchModifyPasswordPriv } = modifyPassword;

  async function handleSumbit() {
    handleStateDataChange({
      graphicCaptchaError: '',
      passwordError: '',
      confirmPasswordError: '',
      oldPasswordError: ''
    });
    const formRes = await form.validateFields().catch(noop);
    console.log('formRes', formRes);

    if (!formRes) return;
    try {
      const res = await fetchModifyPasswordPriv();
      if (!res) return;
      const { status, data } = res;
      if (status === ModifyPasswordResStatus.SUCCESS) {
        // 设置密码成功
        dispatch(appMessageSuccess('设置密码成功'));
        // 更新用户认证信息
        setAuthUserInfo({
          token: data.access_token
        });
        onSuccess && onSuccess();
      }
    } catch (error) {
      console.log('handleSumbit error', error);
      dispatch(appMessageError('设置密码失败，请稍后再试'));
    }
  }

  const handleCancel = () => {
    onSuccess && onSuccess();
  };

  const { oldPassword, mobile, password, confirmPassword, graphicCaptcha } = form.getFieldsValue();
  const submitBtnEnable = useMemo(() => {
    return oldPassword && password && confirmPassword && (!stateData.graphicCaptchaUrl || graphicCaptcha);
  }, [mobile, password, confirmPassword, graphicCaptcha]);

  // eslint-disable-next-line multiline-ternary
  return (
    <div className={styles.formWrapper}>
      {/* <LoginLoading status={loginStatus} /> */}
      <Form form={form} onFieldsChange={onFieldsChange} initialValues={formStore.value}>
        <LoginPasswordItem type="login" name="oldPassword" help={stateData.oldPasswordError} placeholder="原密码" />
        <LoginGraphicCapatchaItem
          src={stateData.graphicCaptchaUrl}
          name="graphicCaptcha"
          help={stateData.graphicCaptchaError}
          onReset={refrashGraphicCaptchaUrl}
        />
        <LoginPasswordItem type="new" name="password" help={stateData.passwordError} />
        <LoginPasswordItem type="confirm" name="confirmPassword" help={stateData.confirmPasswordError} />
        <div className={styles.buttonWrapper}>
          <Button className={styles.buttonCancel} disabled={stateData.modifyLoading} onClick={handleCancel}>
            取消
          </Button>
          <Button
            className={styles.buttonSubmit}
            loading={stateData.modifyLoading}
            disabled={!submitBtnEnable}
            type="primary"
            htmlType="submit"
            onClick={handleSumbit}
          >
            确定
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModifyPasswordComponent;
